module.exports = __webpack_public_path__ + "dc7b6a9528c41852881e7c9d73796216.svg";